import React, { useEffect, useState } from 'react'
import { sanityClient, urlFor } from '../../sanity/client';
import { footerQuery } from '../../sanity/queries';
import "./Footer.css"
import Whatsapp from "../../assets/whatsApp.png";
import Logo from "../../assets/logo.png"

const Footer = () => {
  const [footer, setFooter] = useState(null);

  useEffect(() => {
    sanityClient.fetch(footerQuery).then(setFooter);
  }, []);

  if (!footer) return null;

  return (
    <div className="Footer-container">
      <hr />
      <div className="footer">
        <div className="social-links">
          {footer.socials
            ?.filter((social) => social.enabled)
            .map((social) => (
              <a
                key={social.name}
                href={social.url}
                target="_blank"
                rel="noopener noreferrer"
                aria-label={social.name}
              >
                <img
                  src={urlFor(social.icon)}
                  alt={social.name}
                  loading="lazy"
                />
              </a>
            ))}
        </div>

        {/* WHATSAPP CONTACT */}
        {footer.whatsapp?.enabled && footer.whatsapp.phone && (
          <a
            href={`https://wa.me/${footer.whatsapp.phone}`}
            target="_blank"
            rel="noopener noreferrer"
            className="whatsapp-contact"
            aria-label="Contact us on WhatsApp"
          >
            <img src={Whatsapp} alt="WhatsApp" />
            <span>Chat on WhatsApp</span>
          </a>
        )}

        <div className="logo-f">
          <img src={Logo} alt="" />
        </div>
      </div>
      <div className="blur blur-f-1"></div>
      <div className="blur blur-f-2"></div>
    </div>
  );
}

export default Footer